import { Button } from '@cimplico/components';
import { PaperClipIcon, XMarkIcon } from '@heroicons/react/24/outline';

type TemplateUploadPreviewProps = {
    fileName: string;
    onDelete: () => void;
};

function TemplateUploadPreview({ fileName, onDelete }: TemplateUploadPreviewProps): JSX.Element {
    return (
        <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1">Imported file</label>
            <div className="flex items-center justify-between mt-2 text-sm">
                <div className="flex">
                    <PaperClipIcon className="text-gray-700 h-5 w-5" />
                    <p className="pl-2">{fileName}</p>
                </div>
                <Button leftIcon={<XMarkIcon />} onClick={onDelete} size="sm" type="hollow" />
            </div>
        </div>
    );
}

export default TemplateUploadPreview;
